const isEmptyField = (value?: any) =>
    !value || String(value).trim().length < 1;

const isInvalidEmail = (value?: string) =>
    !value || !value.includes('@') || !value.includes('.') || value.length < 10;

const isIOS = () => {
  const ua = window.navigator.userAgent;
  const platform = window.navigator.platform;
  if (/iPad|iPhone|iPod/.test(ua))  return true;
	if (platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    return true;
  return false;
}

export { isEmptyField, isInvalidEmail, isIOS };